import React from "react";
import Navbar from "../components/Navbar";
import FrontEnd from "./Skills/FrontEnd";
import BackEnd from "./Skills/BackEnd";
import Programming from "./Skills/Programming";
import AI from "./Skills/AI";
import DataAnalysis from "./Skills/DataAnalysis";
import Footer from "../components/Footer";

const About = () => {
  return (
    <div>
      <Navbar />
      <div className="text-white max-w-[800px] mt-[-96px] mb-[20px] w-full h-full mx-auto pl-2 font-main">
        <div className="pt-[150px]">
          <h1 className="text-[#00df9a] uppercase text-3xl">About me</h1>
          <p>
            I am a Master's student in Computer Science with a minor in Artificial 
            Intelligence, combining academic rigor with 2.5 years of industry experience 
            as a Software Developer. My expertise lies in building robust backend 
            applications using Python, MySQL, and related technologies, with a strong 
            track record of delivering high-quality solutions on time. Recently, I’ve 
            transitioned into Data Science to align my practical experience with my 
            academic focus, gaining hands-on exposure in data analysis, machine 
            learning applications and NLP applications, deepening my research skills 
            in AI. As a conceptual learner, I thrive in fast-paced environments and 
            quickly adapt to new technologies. Driven by a passion for innovation 
            and problem-solving, I am confident in my ability to bring significant 
            value to any organization I join.
          </p>
        </div>
        <div className="pt-10 ml-[100px] mr-[100px]">
          <h1 className="text-[#00df9a] uppercase text-3xl text-center border-b ">
            Skills
          </h1>
        </div>
        <FrontEnd />
        <BackEnd />
        <Programming />
        <DataAnalysis />
        <AI />
        <div className="text-white max-w-[800px] pl-2 font-main">
          <div className="pt-10">
            <h1 className="text-[#00df9a] uppercase text-3xl">Key Expertise</h1>
          </div>
          <ul className="list-disc pl-6 pt-2 pb-3">
            <li>
              Good knowledge on machine learning, deep learning models and 
              Natural Language Processing.
            </li>
            <li>
              Familiar with machine learning frameworks and libraries such as 
              PyTorch, Numpy and Pandas etc.
            </li>
            <li>Good knowledge of database systems like MySQL or MongoDB</li>
            <li>
              Good knowledge on HTML, CSS, and JavaScript for creating
              responsive and interactive web applications and familiar with 
              libraries such as Node.js
            </li>
            <li>
              Effective communication, collaboration, time management to deliver
              quality product on time
            </li>
          </ul>
        </div>
        <div className="mt-[10px] mb-[30px]">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default About;
